<div class="modal-header">
    <img *ngIf="medal" class="info" (click)="swish()" alt="Toggle Info">
    <img class="modal-close" (click)="dismissModal()" alt="Dismiss modal">
</div>
<div class="modal-body" [@flipState]="flip">
    <div class="cert-face front" *ngIf="showFront">
        <ng-container *ngIf="badge">
            <div class="face-card">
                <div class="icon badge">&nbsp;</div>
                <div class="normal-text">Badge</div>
                <div class="big-text">{{ badge.badgeName }}</div>
                <div class="small-text">{{ badge.badgeDescription }}</div>
            </div>
            <div class="face-card">
                <div *ngIf="badge.isAwarded" class="small-text bold">{{ motivationalBullshit }}</div>
                <button class="cert-button button_green" (click)="dismissModal()" ngbAutofocus>Close</button>
                <div *ngIf="badge.isAwarded" class="awarded">Awarded on: {{ badge.awardedDateUTC | date: 'dd/MM/yyyy' }}</div>
                <div *ngIf="!badge.isAwarded" class="not-awarded">Not Yet Achieved</div>
            </div>
        </ng-container>
        <ng-container *ngIf="streak">
            <div class="face-card">
                <div class="icon streak">&nbsp;</div>
                <div class="normal-text">{{ streak.streakName }}</div>
                <div class="big-text">{{ streakDuration }}</div>
                <div class="small-text">{{ streak.description }}</div>
            </div>
            <div class="face-card">
                <div class="small-text bold">{{ longestStreakDuration }}</div>
                <button class="cert-button button_green" (click)="dismissModal()" ngbAutofocus>Close</button>
                <div *ngIf="streak.isAwarded" class="awarded">Awarded on: {{ streak.awardedDateUTC | date: 'dd/MM/yyyy' }}</div>
                <div *ngIf="!streak.isAwarded" class="not-awarded">Not Currently Active</div>
            </div>
        </ng-container>
        <ng-container *ngIf="medal">
            <div class="face-card">
                <div class="icon medal">&nbsp;</div>
                <div class="big-text">{{ medal.medalName }}</div>
            </div>
            <div class="face-card">
                <div *ngIf="medal.isCurrent" class="small-text bold">Congratulations!</div>
                <button class="cert-button button_green" (click)="dismissModal()" ngbAutofocus>Close</button>
                <div *ngIf="medal.isAwarded" class="awarded">Awarded on: {{ medal.latestAwardedDate | date: 'dd/MM/yyyy' }}</div>
                <div *ngIf="!medal.isAwarded" class="not-awarded">Not Yet Achieved</div>
            </div>
        </ng-container>
    </div>
    <div class="cert-face back" *ngIf="!showFront">
        <ng-container *ngIf="badge">
            <div class="face-card">
                <div class="normal-text">{{ badge.badgeName }}</div>
                <div class="small-text">{{ badge.badgeDescription }}</div>
            </div>
            <div class="face-card">
                <button class="cert-button button_clear_red" (click)="dismissModal()" ngbAutofocus>Close</button>
            </div>
        </ng-container>
        <ng-container *ngIf="streak">
            <div class="face-card">
                <div class="normal-text">{{ streak.streakName }}</div>
                <div class="small-text">{{ streak.description }}</div>
            </div>
            <div class="face-card">
                <button class="cert-button button_clear_red" (click)="dismissModal()" ngbAutofocus>Close</button>
            </div>
        </ng-container>
        <ng-container *ngIf="medal">
            <div class="face-card">
                <div class="normal-text">{{ medal.medalName }}</div>
                <div class="small-text">{{ medal.medalDescription }}</div>
                <div class="small-text medal-header">Medal Awarded on Dates</div>
                <div class="medal-table">
                    <div class="medal-row" *ngFor="let shiny of medal.medals">
                        <div>{{ shiny.awardedDateUTC | date: 'dd/MM/yyyy' }}</div>
                        <div *ngIf="shiny.winningNumber">{{ shiny.winningNumber }}</div>
                        <div *ngIf="shiny.winningPrice">{{ shiny.winningPrice | currency : 'GBP' }}</div>
                    </div>
                </div>
            </div>
            <div class="face-card">
                <button class="cert-button button_clear_red" (click)="dismissModal()" ngbAutofocus>Close</button>
            </div>
        </ng-container>
    </div>
</div>